import _ from "lodash";
import TickerHyperLinkComponent from "../components/TickerHyperLinkComponent";
import {
  dbDateFormatterForGrid,
  dbTimeFormatterForGrid,
  gridCentsPerShareFormatter,
  myValueFormatter,
  myValueFormatter_quantity,
  rateFormatter,
} from "./commonFunctions";
import { LocateStatus, TradeStatus } from "./constants";
import { validateQuantity, validateRate } from "./tradeValidations";

export const locateEnquiryWorkbookColDefs = [
  {
    headerName: "",
    field: "isSelect",
    floatingFilter: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    headerCheckboxSelection: true,
    showDisabledCheckboxes: true,
    checkboxSelection: true,
    editable: false,
    cellStyle: {
      display: "flex",
      borderRight: "0.3px solid #E1E1E1",
      alignItems: "center",
    },
    pinned: "left",
    lockPinned: true,
    cellClass: "lock-pinned",
    minWidth: 40,
    maxWidth: 50,
    suppressSizeToFit: false,
  },

  {
    headerName: "Ticker",
    field: "ticker",
    floatingFilter: false,
    editable: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (
        params?.node?.data?.status === "Error" &&
        (!params?.node?.data?.ticker || _.isEmpty(params?.node?.data?.ticker))
      ) {
        return {
          display: "flex",
          alignItems: "center",
          
          backgroundColor: TradeStatus.error,
          borderRight: "0.3px solid #E1E1E1",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.3px solid #E1E1E1",
        };
      }
    },
    minWidth: 80,
    maxWidth: 100,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    sortable: true,
    enableCellChangeFlash: false,
  },
   {
    headerName: "Cusip",
    field: "cusip",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: true,
    hide: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (
        params?.node?.data?.status === "Error" &&
        (!params?.node?.data?.ticker || _.isEmpty(params?.node?.data?.ticker))
      ) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: TradeStatus.error,
          borderRight: "0.3px solid #E1E1E1",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.3px solid #E1E1E1",
        };
      }
    },
    minWidth: 80,
    maxWidth: 100,
    enableCellChangeFlash: false,
    suppressSizeToFit: false,
    sortable: true,
  },
  {
    headerName: "Sec Name",
    field: "secName",
    minWidth: 100,
    maxWidth: 300,
    hide: false,
    editable: true,
    filter: "agSetColumnFilter",
    sortable: true,
    enableCellChangeFlash: false,
    cellStyle: function (params: any) {
      if (
        params?.node?.data?.status === "Error" &&
        (!params?.node?.data?.ticker || _.isEmpty(params?.node?.data?.ticker))
      ) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: TradeStatus.error,
          borderRight: "0.3px solid #E1E1E1",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.3px solid #E1E1E1",
        };
      }
    },
  },
 
   {
      headerName: "Price",
      field: "price",
      floatingFilter: false,
      editable: false,
      filter: "agNumberColumnFilter",
      type: "rightAligned",
      floatingFilterComponentParams: { suppressFilterButton: true },
      valueFormatter: myValueFormatter,
      cellStyle: function (params: any) {
        return {
            display: "flex",
            alignItems: "center",
            borderRight: "1px solid #DFDFDF",
            justifyContent: "flex-end",
          }
      },
      minWidth: 90,
      maxWidth: 120,
      
    },
  {
    headerName: "Req Qty",
    field: "request_quantity",
    type: "rightAligned",
    floatingFilter: false,
    editable: true,
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    enableCellChangeFlash: false,
    cellStyle: function (params: any) {
      if (
        params?.node?.data?.status === "Error" &&
        ((params?.node?.data?.request_quantity &&
            !validateQuantity(params?.node?.data?.request_quantity)))
      ) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.3px solid #E1E1E1",
          justifyContent: "flex-end",
          backgroundColor: TradeStatus.error,
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.3px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      }
    },
    minWidth: 90,
    maxWidth: 100,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    sortable: true,
  },
  {
    headerName: "Avl Qty",
    field: "response_quantity",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    enableCellChangeFlash: false,
    cellStyle: function (params: any) {
      if (
        params?.node?.data?.status === "Error" &&
        (!params?.node?.data?.response_quantity ||
          (params?.node?.data?.response_quantity &&
            !validateQuantity(params?.node?.data?.response_quantity)))
      ) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.3px solid #E1E1E1",
          justifyContent: "flex-end",
          backgroundColor: TradeStatus.error,
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.3px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      }
    },
    minWidth: 90,
    maxWidth: 100,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    sortable: true,
  },
  {
    headerName: "Client",
    field: "cpty",
    floatingFilter: false,
    editable: false,
    hide:true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      borderRight: "0.3px solid #E1E1E1",
      alignItems: "center",
    },
    minWidth: 85,
    maxWidth: 110,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    sortable: true,
  },

  {
    filter: "agSetColumnFilter",
    headerName: "User",
    hide:true,
    field: "username",
    sortable: true,
    editable: false,
    minWidth: 90,
    maxWidth: 110,
    cellStyle: function () {
      return {
        display: "flex",
        borderRight: "0.3px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },

  {
    headerName: "Error Code",
    field: "errorCode",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.3px solid #E1E1E1",
      };
    },
    minWidth: 120,
    maxWidth: 160,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    sortable: true,
    enableCellChangeFlash: false,
  },
  {
    headerName: "Status",
    field: "status",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },

    cellStyle: function (params: any) {
      if (params?.node?.data?.status === LocateStatus.Rejected) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.3px solid #E1E1E1",
          color: "#FF0000",
        };
      } else if (
        params?.node?.data?.status === LocateStatus.Approved ||
        params?.node?.data?.status === LocateStatus.Available
      ) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.3px solid #E1E1E1",
          color: "#008000",
        };
      } else if (
        params?.node?.data?.status === LocateStatus.Override ||
        params?.node?.data?.status === LocateStatus.Pending ||
        params?.node?.data?.status === LocateStatus.UnAvailable
      ) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.3px solid #E1E1E1",
          color: "#FFA500",
        };
      } else if (params?.node?.data?.status === "Error") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.3px solid #E1E1E1",
          //  color: "#FF0000",
          backgroundColor: TradeStatus.error,
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.3px solid #E1E1E1",
        };
      }
    },
    minWidth: 120,
    maxWidth: 140,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    sortable: true,
    enableCellChangeFlash: false,
  },
];

export const locateAdminEnquiryColDefs = [
  {
    field: "cpty",
    headerName: "Client",
    minWidth: 80,
    hide: false,
    maxWidth: 100,
    filter: "agMultiColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
   {
    headerName: "User",
    field: "username",
    minWidth: 110,
    filter: "agMultiColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    field: "inquiry_id",
    headerName: "Inquiry Id",
    minWidth: 95,
    hide: true,
    filter: "agMultiColumnFilter",
    cellDataType:'text',
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    headerName: "Account Id",
    field: "account_id",
    minWidth: 100,
    maxWidth: 120,
    hide: true,
    filter: "agMultiColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Source",
    field: "locate_src",
    sortable: true,
    editable: false,
    minWidth: 85,
    maxWidth: 150,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
      };
    },
  },

  {
    field: "ticker",
    minWidth: 75,
    maxWidth: 100,
    filter: "agSetColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
    cellRenderer: TickerHyperLinkComponent,
  },
  {
    headerName: "Sec Name",
    field: "secName",
    minWidth: 160,
    maxWidth: 250,
    hide: true,
    filter: "agSetColumnFilter",
    sortable: true,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
  },
  {
    field: "cusip",
    minWidth: 130,
    hide: true,
    filter: "agSetColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    headerName: "Req qty",
    field: "request_quantity",
    minWidth: 100,
    type: "rightAligned",
    filter: "agMultiColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
        justifyContent: "right",
      };
    },
  },
  {
    headerName: "Avl qty",
    field: "response_quantity",
    type: "rightAligned",
    minWidth: 100,
    filter: "agMultiColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
        justifyContent: "right",
      };
    },
  },
  {
    field: "status",
    headerName: "Status",
    filter: "agSetColumnFilter",
    minWidth: 90,
    // cellRenderer: StatusRenderer,
    cellStyle: function (params: any) {
      if (params?.node?.data?.status === LocateStatus.Rejected) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          // backgroundColor: TradeStatus.error,
          color: "#FF0000",
        };
      } else if (
        params?.node?.data?.status === LocateStatus.Topup ||
        params?.node?.data?.status === LocateStatus.Approved ||
        params?.node?.data?.status === LocateStatus.Available
      ) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          // backgroundColor: TradeStatus.booked,
          color: "#008000",
        };
      } else if (
        params?.node?.data?.status === LocateStatus.Override ||
        params?.node?.data?.status === LocateStatus.Pending ||
        params?.node?.data?.status === LocateStatus.UnAvailable
      ) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          // backgroundColor: TradeStatus.sent,
          color: "#e84679f4",
        };
      }else if ( params?.node?.data?.status === LocateStatus.Partial) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          // backgroundColor: TradeStatus.sent,
          color: "#FFA000",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
  },

  {
    filter: "agMultiColumnFilter",
    headerName: "Avl Rebate",
    field: "rebate",
    sortable: true,
    type: "rightAligned",
    cellDataType: "text",
    editable: function (params: any) {
      return (
        params?.node?.data?.status === LocateStatus.Pending ||
        params?.node?.data?.status === LocateStatus.Rejected
      );
    },
    // cellRenderer: LocateCellEditRenderer,

    minWidth: 95,
    maxWidth: 110,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
        justifyContent: "right",
      };
    },
    enableCellChangeFlash: true,
    valueFormatter: rateFormatter
  },

  {
    headerName: "Req CPS",
    field: "centpershare",
    floatingFilter: false,
    type: "rightAligned",
    editable: function (params: any) {
      return false;
    },
    enableCellChangeFlash: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 85,
    maxWidth: 110,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    valueFormatter: gridCentsPerShareFormatter,
    sortable: true,
  },

  {
    headerName: "Avl CPS",
    field: "centpershare_appr",
    floatingFilter: false,
    type: "rightAligned",
    editable: function (params: any) {
      return false;
    },
    enableCellChangeFlash: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 85,
    maxWidth: 110,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    valueFormatter: gridCentsPerShareFormatter,
    sortable: true,
  },
   
  {
    field: "comments",
    minWidth: 130,
    maxWidth: 170,
    filter: "agMultiColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    headerName: "Req time stamp",
    field: "requested_time",
    minWidth: 150,
    filter: "agMultiColumnFilter",
    hide: false,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
    // valueFormatter: dbTimeFormatterForGrid,
  },
  {
    headerName: "Res time stamp",
    field: "response_time",
    minWidth: 150,
    filter: "agMultiColumnFilter",
    hide: false,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
    // valueFormatter: dbTimeFormatterForGrid,
  },
  // {
  //   headerName: "Action",
  //   minWidth: 220,
  //   maxWidth: 320,
  //   editable: false,
  //   colId: "action",
  //   cellStyle: function () {
  //     return {
  //       display: "flex",
  //       // borderRight: "0.5px solid #E1E1E1",
  //       alignItems: "center",
  //     };
  //   },
  // },
];
